export default {
	home: "Home in es",
	settings: "Settings in es"
}
